import React from "react";
import CategoryProductList from "./CategoryProductList";

const LightParts = () => {
  return (
    <CategoryProductList
      categoryName="Lighting"
      categorySlug="lighting"
    />
  );
};

export default LightParts;
